import { render, staticRenderFns } from "./DataProtectionStatement.vue?vue&type=template&id=45661ac2&lang=true"
import script from "./DataProtectionStatement.vue?vue&type=script&lang=js"
export * from "./DataProtectionStatement.vue?vue&type=script&lang=js"
import style0 from "./DataProtectionStatement.vue?vue&type=style&index=0&id=45661ac2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports